import { Value } from '@philips-internal/oswald-ui-core';

interface ApprovePurchaseRequest {
  approvalSequence: number | string,
  approvalProcessSequence: number | string,
}

interface FormData extends ApprovePurchaseRequest, Record<string, Value> {}

const normalizeApprovePurchaseBody = (approvalSequence: number | string, approvalProcessSequence: number | string): FormData => ({
  approvalSequence: approvalSequence,
  approvalProcessSequence: approvalProcessSequence,
});
  
export {
  normalizeApprovePurchaseBody,
};
